module.exports = __webpack_public_path__ + "img/zqpjlogo.f99fe255.png";